import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as api from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Users } from "lucide-react";

export const HOLDER_END_LABELS = {
    returned_to_stock: "Restitué",
    transferred: "Transféré",
    replaced: "Remplacé",
    assigned: "Réattribué",
    maintenance_start: "Maintenance",
    retired: "Retiré du service",
    lost: "Perdu",
};

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-CH") : "?");

function periodLabel(p) {
    const start = p.handover_date_undefined ? "date non définie" : fmtDate(p.handover_date || p.start);
    if (!p.end) return `Depuis le ${start} — encore attribué`;
    const end = p.return_date_undefined ? "date non définie" : fmtDate(p.return_date || p.end);
    return `Du ${start} au ${end}`;
}

export function ItemHoldersDialog({ item, onClose }) {
    const open = !!item;
    const navigate = useNavigate();
    const [data, setData] = useState(null);

    useEffect(() => {
        if (open) {
            setData(null);
            api.getItemHolders(item.id).then(setData).catch(() => setData({ holders: [] }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, item?.id]);

    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
            <DialogContent className="max-w-lg">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2"><Users className="w-4 h-4 text-teal-600" />Historique des détenteurs — {item?.asset_tag || item?.name}</DialogTitle>
                </DialogHeader>
                <div className="max-h-[55vh] overflow-y-auto" data-testid="holders-dialog">
                    {!data && <p className="text-xs text-gray-400 py-6 text-center">Chargement...</p>}
                    {data && data.holders.length === 0 && <p className="text-xs text-gray-400 py-6 text-center">Ce matériel n'a jamais été attribué</p>}
                    {data && data.holders.map((p, idx) => (
                        <div key={`${p.user_id}-${p.start}`} className="flex items-start justify-between gap-3 py-2.5 border-b border-gray-50 last:border-0" data-testid={`holder-period-${idx}`}>
                            <div className="min-w-0">
                                <button
                                    onClick={() => { onClose(); navigate(`/admin/inventory/employee/${p.user_id}`); }}
                                    className="text-sm font-medium text-gray-800 hover:text-teal-600 hover:underline"
                                    data-testid={`holder-name-${idx}`}
                                >
                                    {p.name}
                                </button>
                                <p className="text-[11px] text-gray-500">{periodLabel(p)}</p>
                                {p.returned_by_name && <p className="text-[10px] text-gray-400">Rendu par {p.returned_by_name}</p>}
                            </div>
                            <span className={`text-[9px] px-1.5 py-0.5 rounded-full font-medium flex-shrink-0 ${!p.end ? "bg-blue-100 text-blue-700" : "bg-gray-100 text-gray-500"}`}>
                                {!p.end ? "Attribué actuellement" : HOLDER_END_LABELS[p.end_action] || "Terminé"}
                            </span>
                        </div>
                    ))}
                </div>
                <DialogFooter><Button variant="outline" onClick={onClose}>Fermer</Button></DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
